import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a5c5191e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "page"
};
import { onMounted } from "vue";
import Bottom from "./components/Bottom.vue";
import Top from "./components/Top.vue";
import Slider from "./components/Slider.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    onMounted(() => {
      // document.dispatchEvent(new Event("render-event"));
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Top), _createVNode(Slider), (_openBlock(), _createBlock(_component_router_view, {
        key: _ctx.$route.fullPath
      })), _createVNode(Bottom)]);
    };
  }
});